import { useSub } from "../../subscription/useSub";
import type { AppRole } from "./navConfig";

/**
 * Derives the current app role used to filter the sidebar.
 *
 * The prototype distinguishes Innkjøpsrådgiver (advisor) and Bestiller (orderer). We map
 * that onto the real permission signal: a user who can create sourcing events manages
 * procurements (advisor); everyone else gets the lighter orderer menu.
 */
export const useAppRole = (): AppRole => {
  const sub = useSub();
  return sub.canCreateEvents ? "advisor" : "orderer";
};
